import { defineAction } from '~/prix'
import geographicalContainment from './geographicalContainment.action.json'
import { z } from 'zod'

const geographicalContainmentDefinition = defineAction({
  ...geographicalContainment,
  input: z.object({
    containerLayerSpace: z.object({
      delimitationType: z.string(),
      delimitationId: z.number(),
      delimitationTitle: z.string(),
    }),
    containedLayerSpace: z.object({
      delimitationType: z.string(),
      delimitationId: z.number(),
      delimitationTitle: z.string(),
    }),
  }),
  output: z.object({
    isContained: z.boolean(),
  }),
})

export default geographicalContainmentDefinition
